export class PobierzKomentarzParowaniaModel {
    idLokalizacji: string;
    idProjektu: string;
    idSrodkaEwidencji: string;
}